import type { ErrorResponse } from "@/lib/types";

export function isError(error: unknown): error is Error {
  return error instanceof Error;
}

export function isResponse(response: unknown): response is Response {
  return response instanceof Response;
}

export function isErrorResponse(response: unknown): response is ErrorResponse {
  return (
    isResponse(response) &&
    "status" in response &&
    typeof (response as ErrorResponse).status === "number"
  );
}

export function isErrorWithStatus(
  error: unknown,
): error is Error & { status: number } {
  return (
    isError(error) &&
    "status" in error &&
    typeof (error as Error & { status: number }).status === "number"
  );
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number";
}

export const isStringArray = (value: unknown): value is string[] => {
  return (
    Array.isArray(value) && value.every((item) => typeof item === "string")
  );
};
